import { message } from "antd";

// Batch upload filenames start with the target alert ID, e.g. "284008_receipt.pdf".
const FILENAME_ALERT_ID_PATTERN = /^(\d+)_.+\.\w+$/i;

export const parseAlertId = (filename) => {
    const match = (filename || "").match(FILENAME_ALERT_ID_PATTERN);
    return match ? match[1] : null;
};

// Returns the alert ID named in the filename when it differs from alertId, otherwise null.
// Compared as numbers so "0284008" matches 284008.
export const mismatchedAlertId = (filename, alertId) => {
    const fileAlertId = parseAlertId(filename);
    if (!fileAlertId || alertId === undefined || alertId === null || alertId === "") return null;
    return Number(fileAlertId) === Number(alertId) ? null : fileAlertId;
};

export const alertIdMismatchMessage = (t, fileAlertId) =>
    t("contents.alerts.document_alert_id_mismatch", { alertId: fileAlertId }) || `Filename refers to alert #${fileAlertId}`;

// Warning only: a leading number can also be a date (e.g. "20240115_receipt.pdf"), so the file is still accepted.
// A fixed key collapses the banners into one when several mismatched files are dropped at once.
export const showAlertIdMismatchWarning = (t, filename, fileAlertId) => {
    message.warning({ content: `${filename}: ${alertIdMismatchMessage(t, fileAlertId)}`, key: "credit-document-alert-id-mismatch", duration: 5 });
};
